import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MentionMeModule } from '@x/common/referral/mention-me/mention-me.module';
import { IReferralModuleConfig, REFERRAL_MODULE_CONFIG } from '@x/common/referral/referral.config';

@NgModule({
  declarations: [],
  imports: [CommonModule, MentionMeModule],
})
export class ReferralModule {
  static forRoot(config?: IReferralModuleConfig): ModuleWithProviders<ReferralModule> {
    return {
      ngModule: ReferralModule,
      providers: [{ provide: REFERRAL_MODULE_CONFIG, useValue: config }],
    };
  }
}
